module.exports = __webpack_public_path__ + "img/clip4.56560d4d.svg";